import React, { ComponentProps } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { FaFileExcel } from 'react-icons/fa';

type Props = React.PropsWithoutRef<ComponentProps<typeof Button>>;

const ButtonExport = (props: Props) => {
  const { t, i18n } = useTranslation();
  return (
    <Button
      {...props}
      style={{ minWidth: '160px' }}
      variant="warning"
      size="sm"
    >
      <FaFileExcel className="mb-1 me-2" />
      {i18n.language === 'gr' ? t('Εξαγωγή σε Excel') : t('Export to Excel')}
    </Button>
  );
};

export default React.memo(ButtonExport);
